import { read, WorkBook } from 'xlsx';
import { v4 as uuidv4 } from 'uuid';

class File {
	/**
	 * Возвращает структуру XLSX файла в callback.
	 * @param callback
	 */
	public getXLSXData = (callback: (data: WorkBook) => void) => {
		const input = document.createElement('input');
		input.type = 'file';
		input.accept = '.xlsx, .ods';
		input.click();
		input.onchange = () => {
			if (!input.files) return;
			const file = input.files[0];
			const reader = new FileReader();
			reader.onloadend = () => {
				if (!reader.result) return;
				const workbook = read(reader.result, {
					type: 'buffer',
					cellStyles: true,
					// raw: true,
					// bookDeps: true,
					// dense: true,
					// bookVBA: true,
					// bookProps: true,
					// cellFormula: true,
					// cellHTML: true,
					// cellNF: true,
					// cellText: true,
					// cellDates: true,
					// sheetStubs: true,
					// bookFiles: true,
					// bookVBA: true,
					// WTF: true,
				});
				callback(workbook);
			};
			reader.readAsArrayBuffer(file); // Загружает файл в reader
		};
	};

	/**
	 * Вовзращает в callback имя, изображение в формате base64 и его размер в байтах.
	 * @param callback
	 */
	public getPictureBase64FromFile = (callback: (name: string, base64: string, size: number) => void) => {
		const input = document.createElement('input');

		// Настроим input
		input.type = 'file';
		input.accept = 'image/*';

		input.onchange = () => {
			if (!input.files || input.files.length === 0) {
				throw new Error('Файл не выбран');
			}

			const file = input.files[0];

			if (!file) {
				throw new Error('Файл не найден');
			}

			const reader = new FileReader();

			reader.onloadend = () => {
				if (!reader.result) {
					throw new Error('Ошибка чтения файла');
				}

				const filename = file.name;
				const base64 = reader.result.toString();

				callback(filename, base64, file.size);
			};

			reader.readAsDataURL(file);
		};

		input.click();
	};
}

export default File;
